import type { MutableRefObject } from "react";
import type { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import type { GridValidRowModel } from "@mui/x-data-grid-premium";

export function getFilteredDataGridRows(
  apiRef: MutableRefObject<GridApiPremium>,
): GridValidRowModel[] {
  if (!apiRef.current) return [];
  const filteredRowsLookup = apiRef.current.state.filter.filteredRowsLookup;
  const sortedRows = apiRef.current.getSortedRows();
  if (Object.keys(filteredRowsLookup).length !== 0) {
    return sortedRows.filter((row) => filteredRowsLookup[row.id as string]);
  }
  return sortedRows;
}
